export default "__VITE_ASSET__CbP5fLdF__"